import React from "react";
import { format, parseISO } from "date-fns";

const STATUS_LABELS = {
  Active: "Ativo",
  Inactive: "Inativo",
  Pending: "Pendente",
};

const formatDate = isoInstant =>
  isoInstant ? format(parseISO(isoInstant), "dd/MM/yyyy") : "—";

// As colunas dependem dos handlers da tela, então saem de uma função em vez de
// serem uma constante de módulo.
export const buildClientColumns = ({ onShowApiKey, onRotate }) => [
  {
    name: "Nome",
    selector: row => row.name,
    sortable: true,
    grow: 2,
  },
  {
    name: "Cliente da Jusfy",
    // null = cliente interno do calculator-api ou cliente desvinculado. A rota
    // deixou de filtrar por vínculo, então essa linha é normal na lista.
    selector: row => row.backendClientId ?? "— não vinculado",
    sortable: true,
    width: "180px",
  },
  {
    name: "Status",
    selector: row => STATUS_LABELS[row.status] ?? row.status,
    sortable: true,
    width: "120px",
  },
  {
    name: "Criado em",
    selector: row => formatDate(row.createdAt),
    sortable: true,
    width: "130px",
  },
  {
    name: "Ações",
    cell: row => (
      <>
        {/* Sem "Editar" nem "Criar vínculo": o PATCH está fora de escopo
            (feature-spec §6), então nome e vínculo se decidem na criação. */}
        <button
          type="button"
          className="btn btn-sm btn-light mr-2"
          onClick={() => onShowApiKey(row)}
        >
          Ver API key
        </button>
        {/* separado do "Ver API key" de propósito: rotacionar mata a key atual
            na hora, e os dois não podem ser confundidos */}
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={() => onRotate(row)}
        >
          Rotacionar
        </button>
      </>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    grow: 2,
  },
];
